import classNames from 'classnames'
import type { FC } from 'react'
import React, { useMemo } from 'react'

import Icon from './icon'
import type { ToggleFlipIconProps } from './types'
import { animatedRotation } from '../../../themes/const'

const ToggleFlipIcon: FC<ToggleFlipIconProps> = props => {
  const {
    className,
    toggleState,
    initialIconOrientation,
    rotateIconOnToggle,
    sx,
    ...rest
  } = props
  const sxStyles = useMemo(
    () => ({
      ...sx,
      ...animatedRotation(initialIconOrientation, rotateIconOnToggle)
    }),
    [initialIconOrientation, rotateIconOnToggle, sx]
  )
  return (
    <Icon
      className={classNames({ 'is-toggle': toggleState }, className)}
      {...rest}
      sx={sxStyles}
    />
  )
}

export default ToggleFlipIcon
